import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';
export class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { hasError: false, error: null };
        this.handleReload = () => {
            window.location.reload();
        };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    render() {
        if (this.state.hasError) {
            return (_jsxs("div", { className: "flex flex-col items-center justify-center h-full px-8", style: { background: '#0A0A0A' }, children: [_jsx(AlertTriangle, { className: "w-12 h-12 text-pink-400/40 mb-4" }), _jsx("h2", { className: "text-white font-bold text-[18px] mb-2", children: "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A" }), _jsx("p", { className: "text-white/40 text-[13px] text-center mb-6 max-w-[280px]", children: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435." }), _jsxs("button", { onClick: this.handleReload, className: "btn-cta px-6 py-3 text-[14px] font-semibold flex items-center gap-2", children: [_jsx(RotateCcw, { className: "w-4 h-4" }), "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C"] })] }));
        }
        return this.props.children;
    }
}
